import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from '../../axiosConfig';
import '../../styles/NewAuth.css';

const AddOpeningHours = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Otrzymujemy dane z poprzednich kroków (z RegisterTrainer i RegisterSchool)
    const { trainerData, schoolData } = location.state || {};

    // Lista dni tygodnia – backend oczekuje np. MONDAY, TUESDAY, ... w uppercase
    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    // Inicjalizujemy stan godzin otwarcia
    // Każdy klucz (Monday, Tuesday...) ma obiekt { openingTime: '', closingTime: '' }
    const [openingHours, setOpeningHours] = useState(
        daysOfWeek.reduce((acc, day) => ({
            ...acc,
            [day]: { openingTime: '', closingTime: '' }
        }), {})
    );

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Jeśli nie mamy danych z poprzednich kroków, wracamy do rejestracji trenera
    useEffect(() => {
        if (!trainerData || !schoolData) {
            navigate('/register-trainer');
        }
    }, [trainerData, schoolData, navigate]);

    // Aktualizacja godzin otwarcia w stanie
    const handleChange = (day, field, value) => {
        setOpeningHours((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                [field]: value
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // 1️⃣ Budujemy request zgodny z RegisterTrainerRequest
            const trainerRequest = {
                username: trainerData.username,
                password: trainerData.password,
                firstName: trainerData.firstName,
                lastName: trainerData.lastName,
                email: trainerData.email,
                phone: trainerData.phone,
                address: {
                    country: trainerData.country,
                    city: trainerData.city,
                    postalCode: trainerData.postalCode,
                    street: trainerData.street,
                    buildingNumber: trainerData.buildingNumber,
                    apartmentNumber: trainerData.apartmentNumber,
                }
            };

            // Rejestrujemy trenera
            const trainerResponse = await axios.post('/api/v1/auth/register/trainer', trainerRequest);
            const trainerId = trainerResponse.data; // UUID zwrócony przez backend

            // 2️⃣ Budujemy request dla szkoły (CreateSchoolRequest)
            const schoolRequest = {
                name: schoolData.name,
                address: {
                    country: schoolData.country,
                    city: schoolData.city,
                    postalCode: schoolData.postalCode,
                    street: schoolData.street,
                    buildingNumber: schoolData.buildingNumber,
                    apartmentNumber: schoolData.apartmentNumber,
                },
                phone: schoolData.phone,
                email: schoolData.email,
            };

            // Tworzymy szkołę (endpoint z {trainerId} w URL)
            const schoolResponse = await axios.post(`/api/v1/school/create/${trainerId}`, schoolRequest);
            const schoolId = schoolResponse.data.id;

            // 3️⃣ Przygotowujemy listę godzin otwarcia
            // Każdy element: { dayOfWeek, openingTime, closingTime }
            const formattedHours = Object.entries(openingHours)
                .filter(([_, times]) => times.openingTime && times.closingTime)
                .map(([day, times]) => ({
                    dayOfWeek: day.toUpperCase(),
                    openingTime: times.openingTime,
                    closingTime: times.closingTime,
                }));

            // Jeśli nie ustawiono żadnych godzin, wyświetlamy błąd
            if (formattedHours.length === 0) {
                setError('Proszę podać co najmniej jeden dzień godzin otwarcia.');
                setLoading(false);
                return;
            }

            // Dodajemy godziny otwarcia
            await axios.post(`/api/v1/school/${schoolId}/opening-hours`, formattedHours);

            // 4️⃣ Przekierowanie do strony sukcesu
            navigate('/registration-success');
        } catch (err) {
            setError('Coś poszło nie tak. Spróbuj ponownie.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>Ustaw godziny otwarcia</h1>
                <form className="auth-form" onSubmit={handleSubmit}>
                    <table className="opening-hours-table">
                        <thead>
                        <tr>
                            <th>Dzień tygodnia</th>
                            <th>Godzina otwarcia</th>
                            <th>Godzina zamknięcia</th>
                        </tr>
                        </thead>
                        <tbody>
                        {daysOfWeek.map((day) => (
                            <tr key={day}>
                                <td>{day}</td>
                                <td>
                                    <input
                                        type="time"
                                        value={openingHours[day].openingTime}
                                        onChange={(e) => handleChange(day, 'openingTime', e.target.value)}
                                        placeholder="Godzina otwarcia"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="time"
                                        value={openingHours[day].closingTime}
                                        onChange={(e) => handleChange(day, 'closingTime', e.target.value)}
                                        placeholder="Godzina zamknięcia"
                                    />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {error && <p className="error">{error}</p>}

                    <button type="submit" disabled={loading}>
                        {loading ? 'Zapisywanie...' : 'Gotowe!'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddOpeningHours;
